import React, { Fragment, useState } from 'react'
import SolicitudComponent from '../Solicitudes/SolicitudComponent';

function SolicitudesPorAsociadoComponent(props) {

    const solicitudes = props.solicitudes;
    const asociado = props.asociado
    React.useEffect(() => {
        console.log(solicitudes)
        console.log(asociado)
    }, [])

    return (
        <Fragment>
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-2`}>
                <h3>Solicitudes del Asociado: {asociado.cliente.nombrerazonsocial} | {asociado.tipodeunidad}</h3>
                {
                    solicitudes.map((solicitud, index) => (
                        <SolicitudComponent key={index} solicitud={solicitud} user={2} status={1} tipo={1} isCalendario={null} isZonas={true} actualizarSolicitudes={props.actualizarSolicitudes} handleCerrarModalSolicitudes={props.handleCerrarModalSolicitudes}></SolicitudComponent>
                    ))
                }
                <button onClick={() => props.handleCerrarModalSolicitudes()} className='btn btn-success'>Aceptar</button>
            </div>
        </Fragment>
    )
}

export default SolicitudesPorAsociadoComponent